
    import { defineComponent } from 'vue'

    import PortalPage from '@/components/common/portal-page.vue'
    import SparepartView from '@/components/spareparts/sparepart-view.vue'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'AllSparepartsCatalog',

        components: {
            PortalPage,
            SparepartView
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const allModelsKey = 'all'

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const pageTitle = localize('AllSpareParts')

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { allModelsKey, pageTitle }
        }
    });
